import { render, staticRenderFns } from "./PechatFooter.vue?vue&type=template&id=19838c6a"
var script = {}
import style0 from "./PechatFooter.vue?vue&type=style&index=0&id=19838c6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports